var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"res-circle"},[_c('div',{staticClass:"circle-txt"},[_vm._v(_vm._s(_vm.number))]),(_vm.withAttach > 0)?_c('div',{staticClass:"badge"},[_vm._v(" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }